import { OccupationType, PropertyType } from 'shared/constants/kycTypes'
import { IKycData } from 'shared/interfaces/i-api-kyc'
import { FormatEnumToList, CountrySpecificValues } from 'shared/utils/helpers'
import { useTranslation } from 'react-i18next'
import { TranslationFile } from 'i18n'

export const LoanInformationFormFi = (data: IKycData) => {
	const { t } = useTranslation([
		TranslationFile.Translation,
		TranslationFile.Forms,
	])
	return {
		fieldSetName: t('forms:LoanInfoHeader'),
		formName: 'FirstAndTwoThirds',
		description: t('forms:LoanInfoDescription'),
		show: false,
		visible: true,
		controls: [
			{
				options: FormatEnumToList(
					OccupationType,
					PropertyType.Occupation,
					TranslationFile.Dropdown
				),
				required: true,
				controlName: 'occupationType',
				type: 'dropdown',
				label: t('forms:Occupation'),
				col: 12,
				value: data.employments[0].occupationType,
				visible: true,
			},
			{
				options: CountrySpecificValues('', PropertyType.Income),
				required: true,
				controlName: 'income',
				type: 'dropdown',
				label: t('forms:AnnualIncome'),
				col: 12,
				value: data.employments[0].income,
				visible: true,
			},
		],
	}
}
